import CardContent from '@mui/material/CardContent';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Column from 'components/Layout/Column';
import Row from 'components/Layout/Row';
import {
  numberToCurrencyString,
  numberToPercentageString,
  renderMultiple,
} from 'further-ui/utils';
import { blue } from '@mui/material/colors';
import { Box, Skeleton, styled } from '@mui/material';
import {
  CurrencyExchangedValue,
  CurrencySettings,
  FundPerformanceMetric,
} from '../../types';

const InlineTextSkeleton = styled(Skeleton)({
  display: 'inline-block',
  width: 60,
});

const BlueBar = styled(Box)(() => ({
  width: '100%',
  height: '8px',
  backgroundColor: blue[500],
}));

const Card = styled(MuiCard)({
  flexGrow: 1,
});

type Props = {
  label: string;
  calculatingCurrencyConversions?: boolean;
  showInvestorConvertedCurrency?: boolean;
} & Pick<CurrencySettings, 'investorCurrency' | 'currencyLcy'> &
  FundPerformanceMetric &
  Partial<CurrencyExchangedValue>;

const PerformanceCard: React.FC<Props> = ({
  label,
  value,
  currencyLcy,
  investorCurrency,
  symbol,
  valueTcy,
  valueLcy,
  calculatingCurrencyConversions,
  showInvestorConvertedCurrency,
}) => {
  return (
    <Card variant="outlined" key={label}>
      <CardContent>
        <Column centered spacing="xxs">
          <Typography variant="h6" color="grey.600">
            {label}
          </Typography>
          <Typography variant="h3">
            {symbol === 'multiple'
              ? renderMultiple(value)
              : numberToPercentageString(value, { noMultiply: true })}
          </Typography>
          {typeof valueLcy === 'number' ? (
            <Row spacing="xs">
              <Typography variant="body2" color="grey.900">
                {numberToCurrencyString(valueLcy, {
                  currency: currencyLcy,
                })}
              </Typography>
              <Typography variant="body2">
                {showInvestorConvertedCurrency ? (
                  calculatingCurrencyConversions ? (
                    <InlineTextSkeleton />
                  ) : (
                    numberToCurrencyString(valueTcy, {
                      currency: investorCurrency,
                    })
                  )
                ) : null}
              </Typography>
            </Row>
          ) : null}
        </Column>
      </CardContent>
      <BlueBar />
    </Card>
  );
};

export default PerformanceCard;
